// extracted by mini-css-extract-plugin
export default {"recos":"k7-z","productCardOverride":"l7-z","rowHasBadge":"m7-z"};